<template>
  <el-dialog title="请选择账号" :visible.sync="dialogFormVisible" width="60%" center :close-on-click-modal="false" top="7vh" :modal-append-to-body="false">
    <el-input type="text"  v-model="searchTenantName" placeholder="输入关键字" size="mini" style="width:180px"></el-input><br>
    <el-tag type="success" effect="plain" :key="unitguid" v-for="tenant in datalist" v-if="!searchTenantName||tenant.tenantname.indexOf(searchTenantName)>-1" @click="handleClick(tenant)" style="cursor: pointer;margin-right: 50px;margin-bottom: 15px">
      {{tenant.tenantname}}  <span style="color: #9B9B9B">{{tenant.appname}}</span></el-tag>
    <!--<el-table-->
      <!--:data="datalist"-->
      <!--:height="'300px'"-->
      <!--size="mini" :show-header="false"-->
      <!--:current-row-key="'unitguid'"-->
      <!--style="width: 100%;">-->
      <!--<el-table-column label="企业名称" align="left">-->
        <!--<template slot-scope="scope">-->
          <!--<p style="font-size: 22px;cursor: pointer;"  @click="handleClick(scope.$index, scope.row)">{{scope.row.tenantname}}</p>-->

        <!--</template>-->
      <!--</el-table-column>-->
    <!--</el-table>-->
  </el-dialog>
</template>
<script>
  export default {

    data() {
      return {
        dialogFormVisible: false,
        searchTenantName:'',
      }
    },
    props: ['datalist'],
    methods: {
      handleClick( row) {
        this.$emit("selectTenant", row);

      },
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/TenantList.vue